import React, { Suspense } from 'react';
import { FederatedModule } from '@bfme-technology/spa';



import type { ExpenseAnalyticsMfeProps } from './ExpenseAnalyticsMfe.types';

export const ExpenseAnalyticsMfe: React.FC<ExpenseAnalyticsMfeProps> = ({ t }) => {
  return (
    <Suspense
      fallback={<div className="p-4 text-text-muted">Loading Analytics Widget...</div>}
    >
      <FederatedModule
        mfeKey="mfe-expense-manager"
        module="./AnalyticsWidget"
        mfeProps={{ t }}
      />
    </Suspense>
  );
};
